"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.for-each.js");
var _phaser = _interopRequireDefault(require("phaser"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class PreloadScene extends _phaser.default.Scene {
  constructor() {
    super("PreloadScene");
  }
  preload() {
    this.load.pack('asset_pack', '/space-shooter-assets/data/assets.json');
  }
  create() {
    this.createAnimations();
    this.scene.start("GameScene");
  }
  createAnimations() {
    const data = this.cache.json.get('animations_json');
    data.forEach(animation => {
      const frames = animation.frames ? this.anims.generateFrameNumbers(animation.assetKey, {
        frames: animation.frames
      }) : this.anims.generateFrameNumbers(animation.assetKey);
      this.anims.create({
        key: animation.key,
        frames: frames,
        frameRate: animation.frameRate,
        repeat: animation.repeat
      });
    });
  }
}
var _default = exports.default = PreloadScene;